import Vue from 'vue';
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import Vuetify from 'vuetify'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/app-tables.css';
//import { BootstrapVue } from 'bootstrap-vue'; 

//import UploaderPlugin  from '@syncfusion/ej2-vue-inputs';
import locale from 'element-ui/lib/locale/lang/en'
import BlockUIService from './Shared/BlockUIService.js';

import App from './App.vue';
import Layout from './components/Layout/Layout.vue';
import Login from './components/Login/Login.vue';
import Home from './components/Home/Home.vue';
import DataService from './Shared/DataService';
import Helper from './Shared/Helper';
import OverviewStats from './Shared/OverviewStats.vue';


import VueEllipseProgress from 'vue-ellipse-progress';





//Products
import Products from './components/Products/Products.vue';
import ProductDetails from './components/Products/ProductDetails.vue';
import ProductsAnalytics from './components/Products/ProductsAnalytics/ProductsAnalytics.vue';
import ProductsReports from './components/Products/ProductsReports/ProductsReports.vue';
import ProductsManage from './components/Products/ProductsManage/ProductsManage.vue';
import Formulary from './components/Formulary/Formulary.vue';
import ProductsCounts from './components/Products/ProductsCounts/ProductsCounts.vue';




//Dictionaries
import Categories from './components/Dictionaries/Categories/Categories.vue';
import UnitMeasures from './components/Dictionaries/UnitMeasures/UnitMeasures.vue';
import Countries from './components/Dictionaries/Countries/Countries.vue';
import Customers from './components/Dictionaries/Customers/Customers.vue';
import Stocking from './components/Dictionaries/Stocking/Stocking.vue';
import PaymentsMethods from './components/Dictionaries/PaymentsMethods/PaymentsMethods.vue';
import Suppliers from './components/Dictionaries/Suppliers/Suppliers.vue';
import Branches from './components/Dictionaries/Branches/Branches.vue';
import BranchAddWizard from './components/Dictionaries/Branches/BranchAddWizard.vue';
import FacilityDepartments from './components/FacilityDepartments/FacilityDepartments.vue';
import Manufacturers from './components/Dictionaries/Manufacturers/Manufacturers.vue';
import StorageTemperature from './components/Dictionaries/StorageTemperature/StorageTemperature.vue';

//Financial
import Financial from './components/Financial/Financial.vue';


//Users
import Users from './components/Users/Users.vue';
import UsersProfile from './components/Users/Profile/Profile.vue';
import MedicineOrders from './components/MedicineOrders/MedicineOrders.vue';
import ReceiptVerification from './components/ReceiptVerification/ReceiptVerification.vue';
import ReturnOrders from './components/ReturnOrders/ReturnOrders.vue';
import DamageReports from './components/DamageReports/DamageReports.vue';
import StockVouchers from './components/StockVouchers/StockVouchers.vue';
import NonFormularyRequests from './components/NonFormularyRequests/NonFormularyRequests.vue';
import ProductAdditionRequests from './components/ProductAdditionRequests/ProductAdditionRequests.vue';
import FacilityNationalFormulary from './components/FacilityNationalFormulary/FacilityNationalFormulary.vue';
import ExternalPurchaseRequests from './components/ExternalPurchaseRequests/ExternalPurchaseRequests.vue';
import PatientDispenses from './components/PatientDispenses/PatientDispenses.vue';
import PatientDispensesMonitor from './components/PatientDispenses/PatientDispensesMonitor.vue';
import SurplusRequests from './components/SurplusRequests/SurplusRequests.vue';
import RotationTransfers from './components/RotationTransfers/RotationTransfers.vue';
import InventoryCounts from './components/InventoryCounts/InventoryCounts.vue';
import OpeningStockImport from './components/OpeningStockImport/OpeningStockImport.vue';
import InventoryAlerts from './components/InventoryAlerts/InventoryAlerts.vue';
import Notifications from './components/Notifications/Notifications.vue';
import WorkflowDefinitions from './components/WorkflowDefinitions/WorkflowDefinitions.vue';
import BranchUsers from './components/BranchUsers/BranchUsers.vue';
import WarehouseMovements from './components/WarehouseMovements/WarehouseMovements.vue';
import Warehouse from './components/Warehouse/Warehouse.vue';
import StockMovements from './components/Warehouse/StockMovements.vue';
import InventoryCount from './components/Inventory/InventoryCount.vue';
import InventoryCountDetails from './components/Inventory/InventoryCountDetails.vue';
import InventoryCountPeriods from './components/Inventory/InventoryCountPeriods.vue';
import RecycleRequests from './components/Recycling/RecycleRequests.vue';
import RecycleReview from './components/Recycling/RecycleReview.vue';
import StockAvailability from './components/Recycling/StockAvailability.vue';
import PharmacyReports from './components/PharmacyReports/PharmacyReports.vue';
import SupplyOrders from './components/SupplyOrders/SupplyOrders.vue';
import NeedEstimates from './components/NeedEstimates/NeedEstimates.vue';
import Dispatch from './components/Dispatch/Dispatch.vue';
import DispatchNew from './components/Dispatch/DispatchNew.vue';
import DispatchForm from './components/Dispatch/DispatchForm.vue';
import DispatchV2 from './components/Dispatch/DispatchV2.vue';
import DispatchFormV2 from './components/Dispatch/DispatchFormV2.vue';
import DispatchV3 from './components/Dispatch/DispatchV3.vue';
import DirectDispatch from './components/DirectDispatch/DirectDispatch.vue';
import DirectDispatchReceive from './components/DirectDispatch/DirectDispatchReceive.vue';
import FormularyReview from './components/FormularyReview/FormularyReview.vue';
import InventoryReports from './components/InventoryReports/InventoryReports.vue';
import StockReports from './components/Reports/StockReports.vue';
import FacilityOnboardingHold from './components/FacilityOnboarding/FacilityOnboardingHold.vue';
import PharmacyDashboard from './components/Pharmacy/PharmacyDashboard.vue';
import OfficialVouchers from './components/Documents/OfficialVouchers.vue';
import ComprehensiveReports from './components/Reports/ComprehensiveReports.vue';
import MainDashboard from './components/Dashboard/Dashboard.vue';
import SystemSettings from './components/Settings/SystemSettings.vue';


import CryptoJS from 'crypto-js';

const PlatformLoginDecryptPass = 'Traneem!@Platformv1';

const facilityOnboardingPharmacyHoldPath = '/FacilityOnboarding/AwaitingPharmacyReview';
const facilityOnboardingMinistryHoldPath = '/FacilityOnboarding/AwaitingMinistryApproval';

function getFacilityOnboardingStatusFromStoredUser(u) {
    if (!u) return null;
    const raw = u.facilityOnboardingStatus ?? u.FacilityOnboardingStatus;
    if (raw === null || raw === undefined || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
}

function isFacilityOnboardingGateUser(u) {
    return !!(u && u.branchesId && [2, 5, 6].includes(Number(u.userType)));
}

function parseEncryptedLoginUser() {
    const raw = localStorage.getItem('currentUser-client');
    if (!raw) return null;
    try {
        const decrypted = CryptoJS.AES.decrypt(raw, PlatformLoginDecryptPass);
        const str = decrypted.toString(CryptoJS.enc.Utf8);
        return str ? JSON.parse(str) : null;
    } catch {
        return null;
    }
}


Vue.use(VueEllipseProgress);

Vue.use(Vuetify)
Vue.use(VueI18n);
Vue.use(VueRouter);
//Vue.use(UploaderPlugin);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;
Vue.prototype.$helper = Helper;
Vue.component('OverviewStats', OverviewStats);
//Vue.use(BootstrapVue);


export const eventBus = new Vue();


const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    linkActiveClass: 'active',
    routes: [
        // يُستخدم من المعترض وHelper عند انتهاء الجلسة؛ بدون مسار يبقى router-view فارغاً على /Login
        { path: '/Login', name: 'LoginPage', component: Login },
        {
            path: facilityOnboardingPharmacyHoldPath,
            name: 'FacilityOnboardingPharmacy',
            component: FacilityOnboardingHold
        },
        {
            path: facilityOnboardingMinistryHoldPath,
            name: 'FacilityOnboardingMinistry',
            component: FacilityOnboardingHold
        },
        {
            path: '/',
            component: Login,
         
        },
         {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    component: Layout,
                    children: [
                        { path: '/Home', component: Home },


                        //Products
                        { path: 'Products', component: Products },
                        { path: 'Products/Analytics', name: 'ProductsAnalytics', component: ProductsAnalytics },
                        { path: 'Products/Reports', name: 'ProductsReports', component: ProductsReports },
                        { path: 'Products/:id', name: 'ProductDetails', component: ProductDetails },
                        { path: 'ProductsManage', component: ProductsManage },
                        { path: 'ProductsCounts', component: ProductsCounts },
                        { path: 'InvoiceIn', redirect: '/Procurement' },
                        { path: 'InvoiceOut', redirect: '/Procurement' },




                     
                        //Dictionaries
                        { path: 'Categories', component: Categories },
                        { path: 'UnitMeasures', component: UnitMeasures },
                        { path: 'Countries', component: Countries },
                        { path: 'Formulary', component: Formulary },
                        { path: 'Branches', component: Branches },
                        // مقطع مسار واحد (/AddBranch) حتى لا يُحلّ "api/..." تحت /Branches/api/... (index.html → يُعتقد انتهاء الجلسة).
                        { path: 'Branches/add', redirect: { name: 'BranchAddWizard' } },
                        { path: 'AddBranch', name: 'BranchAddWizard', component: BranchAddWizard },
                        { path: 'Manufacturers', component: Manufacturers },
                        { path: 'Customers', component: Customers },
                        { path: 'Stocking', component: Stocking },
                        { path: 'Suppliers', component: Suppliers },
                        { path: 'PaymentsMethods', component: PaymentsMethods },
                        { path: 'StorageTemperatures', component: StorageTemperature },

                        //Financial
                        { path: 'Financial', component: Financial },

                        //Users — مسار الإضافة قبل القائمة حتى يُطابق بشكل صحيح
                        { path: 'Users/add', name: 'UsersAdd', component: Users },
                        { path: 'Users', name: 'Users', component: Users },
                        { path: 'UsersProfile', component: UsersProfile },
                        { path: 'MedicineOrders', component: MedicineOrders },
                        { path: 'ReceiptVerification', component: ReceiptVerification },
                        { path: 'ReturnOrders', component: ReturnOrders },
                        { path: 'DamageReports', component: DamageReports },
                        { path: 'StockVouchers', component: StockVouchers },
                        { path: 'NonFormularyRequests', component: NonFormularyRequests },
                        { path: 'ProductAdditionRequests', component: ProductAdditionRequests },
                        { path: 'FacilityNationalFormulary', component: FacilityNationalFormulary },
                        { path: 'Procurement', component: ExternalPurchaseRequests },
                        { path: 'ExternalPurchaseRequests', component: ExternalPurchaseRequests },
                        { path: 'PatientDispenses', component: PatientDispenses },
                        { path: 'PatientDispensesMonitor', component: PatientDispensesMonitor },
                        { path: 'SurplusRequests', component: SurplusRequests },
                        { path: 'RotationTransfers', component: RotationTransfers },
                        { path: 'InventoryCounts', component: InventoryCounts },
                        { path: 'OpeningStockImport', component: OpeningStockImport },
                        { path: 'InventoryAlerts', component: InventoryAlerts },
                        { path: 'Notifications', component: Notifications },
                        { path: 'WorkflowDefinitions', component: WorkflowDefinitions },
                        { path: 'BranchUsers/add', name: 'BranchUsersAdd', component: BranchUsers },
                        { path: 'BranchUsers', name: 'BranchUsers', component: BranchUsers },
                        { path: 'WarehouseMovements', component: WarehouseMovements },
                        { path: 'WarehouseMonitoring', component: WarehouseMovements },
                        { path: 'Warehouse', name: 'WarehouseManagement', component: Warehouse },
                        { path: 'Warehouse/StockMovements', name: 'WarehouseStockMovements', component: StockMovements },
                        { path: 'InventoryCount', name: 'InventoryCount', component: InventoryCount },
                        { path: 'InventoryCountPeriods', name: 'InventoryCountPeriods', component: InventoryCountPeriods },
                        { path: 'RecycleRequests', name: 'RecycleRequests', component: RecycleRequests },
                        { path: 'RecycleReview', name: 'RecycleReview', component: RecycleReview },
                        { path: 'StockAvailability', name: 'StockAvailability', component: StockAvailability },
                        { path: 'PharmacyReports', name: 'PharmacyReports', component: PharmacyReports },
                        { path: 'SupplyOrders', name: 'SupplyOrders', component: SupplyOrders },
                        { path: 'NeedEstimates', name: 'NeedEstimates', component: NeedEstimates },
                        { path: 'InventoryCount/Details/:id', name: 'InventoryCountDetails', component: InventoryCountDetails, props: true },
                        { path: 'InventoryCount/:id', redirect: (to) => ({ name: 'InventoryCountDetails', params: { id: to.params.id } }) },
                        { path: 'Dispatch', name: 'DispatchManagement', component: Dispatch },
                        { path: 'DispatchNew', name: 'DispatchNewList', component: DispatchNew },
                        { path: 'DispatchNew/Create', name: 'DispatchNewCreate', component: DispatchForm },
                        { path: 'DispatchNew/Edit/:id', name: 'DispatchNewEdit', component: DispatchForm, props: true },
                        { path: 'DispatchV2', name: 'DispatchV2List', component: DispatchV2 },
                        { path: 'DispatchV2/Create', name: 'DispatchV2Create', component: DispatchFormV2 },
                        { path: 'DispatchV2/Edit/:id', name: 'DispatchV2Edit', component: DispatchFormV2, props: true },
                        { path: 'DispatchV3', name: 'DispatchV3Management', component: DispatchV3 },
                        { path: 'DirectDispatch', component: DirectDispatch },
                        { path: 'DirectDispatchReceive', component: DirectDispatchReceive },
                        { path: 'FacilityDepartments', component: FacilityDepartments },
                        { path: 'FormularyReview', component: FormularyReview },
                        { path: 'InventoryReports', component: InventoryReports },
                        { path: 'StockReports', name: 'StockReports', component: StockReports },
                        { path: 'PharmacyDashboard', name: 'PharmacyDashboard', component: PharmacyDashboard },
                        { path: 'OfficialVouchers', name: 'OfficialVouchers', component: OfficialVouchers },
                        { path: 'ComprehensiveReports', name: 'ComprehensiveReports', component: ComprehensiveReports },
                        { path: 'Dashboard', name: 'MainDashboard', component: MainDashboard },
                        { path: 'SystemSettings', name: 'SystemSettings', component: SystemSettings },
                        

                       
                       
                    ]
                },
            ],
        }
    ]
});

router.beforeEach((to, from, next) => {
    const p = to.path || '';
    const u = parseEncryptedLoginUser();

    if (p.startsWith('/FacilityOnboarding/') && !u) {
        next({ path: '/Login' });
        return;
    }

    if (p.startsWith('/FacilityOnboarding/') && u && !isFacilityOnboardingGateUser(u)) {
        next({ path: '/Home' });
        return;
    }

    const st = getFacilityOnboardingStatusFromStoredUser(u);

    if (p.startsWith('/FacilityOnboarding/') && isFacilityOnboardingGateUser(u)) {
        if (p.startsWith(facilityOnboardingPharmacyHoldPath) && st !== 2) {
            if (st === 1) next({ path: '/InventoryCounts' });
            else if (st === 3) next({ path: facilityOnboardingMinistryHoldPath });
            else next({ path: '/Home' });
            return;
        }
        if (p.startsWith(facilityOnboardingMinistryHoldPath) && st !== 3) {
            if (st === 1) next({ path: '/InventoryCounts' });
            else if (st === 2) next({ path: facilityOnboardingPharmacyHoldPath });
            else next({ path: '/Home' });
            return;
        }
    }

    if (isFacilityOnboardingGateUser(u) && st === 1) {
        const allowed =
            p.startsWith('/InventoryCounts') ||
            p.startsWith('/OpeningStockImport') ||
            p.startsWith('/UsersProfile');
        if (!allowed) {
            next({ path: '/InventoryCounts' });
            return;
        }
    }

    if (isFacilityOnboardingGateUser(u) && st === 2) {
        if (!p.startsWith(facilityOnboardingPharmacyHoldPath)) {
            next({ path: facilityOnboardingPharmacyHoldPath });
            return;
        }
    }

    if (isFacilityOnboardingGateUser(u) && st === 3) {
        if (!p.startsWith(facilityOnboardingMinistryHoldPath)) {
            next({ path: facilityOnboardingMinistryHoldPath });
            return;
        }
    }

    next();
});



Vue.filter('toUpperCase', function (value) {
    if (!value) return '';
    return value.toUpperCase();
});

new Vue({
    router,
    render: h => {
        return h(App);
    }
}).$mount('#cpanel-management');
